import React, { createRef, useEffect, useRef, useState } from 'react'
import { generateData, nominationThunks } from '@/entity/nomination'
import { useDispatch, useSelector } from 'react-redux'
import cl from 'classnames'
import { Modal } from '../Modal'
import { NominationHeader } from '@features/nomination/NominationHeader'
import { AntdTable } from '@/components/AntdTable/AntdTable'
import { useTranslation } from 'react-i18next'
import { ExpandableText } from '@/components/ExpandableText/ExpandableText'
import { DownloadLink } from '@features/nomination/DownloadLink'

export const ViewModal = ({ item, onClose, onSuccess }) => {
	const { t } = useTranslation()
	const dispatch = useDispatch()

	const [data, setData] = useState([])

	const { dictValues } = useSelector((state) => ({
		dictValues: state.nomination.dictValues,
	}))

	useEffect(() => {
		let body = {
			data: { nominationCode: item?.nomination?.code },
			onSuccess: (res) => {
				let params = generateData(item?.paramValues, res, dictValues?.data)
				let sorted = params?.sort((a, b) => a?.orderNum > b?.orderNum ? 1 : -1)
				setData(sorted)
			},
		}

		dispatch(nominationThunks.getDictParams(body))
	}, [])

	const columns = [
		{
			key: 'criterion',
			dataIndex: 'title',
			title: t('nomination.criterion'),
		},
		{
			key: 'employer_data',
			dataIndex: 'employer_data',
			title: t('employer_data'),
			width: 250,
			render: (item, record, index) => {
				return (
					<div className={cl('flex', 'flex-column', 'gap-3')}>
						<ExpandableText>
							{item || '-'}
						</ExpandableText>

						{record.employer_file && <DownloadLink id={record.employer_file}/>}
					</div>
				)
			}
		},
		{
			key: 'comp_data',
			dataIndex: 'comp_data',
			title: t('nomination.is_data'),
			width: 180,
			render: (item, record, index) => {
				return (
					<div className={cl('flex', 'flex-column', 'gap-3')}>
						<ExpandableText>
							{item || '-'}
						</ExpandableText>

						{record.comp_file && <DownloadLink id={record.comp_file}/>}
					</div>
				)
			},
		},
		{
			key: 'mio_data',
			dataIndex: 'mio_data',
			title: t('nomination.mio_data'),
			width: 180,
			render: (item, record, index) => {
				return (
					<div className={cl('flex', 'flex-column', 'gap-3')}>
						<ExpandableText>
							{item || '-'}
						</ExpandableText>

						{record.mio_file && <DownloadLink id={record.mio_file}/>}
					</div>
				)
			},
		},
		{
			key: 'mioComment',
			dataIndex: 'mioComment',
			title: t('staff_modal.comment'),
			width: 180,
			render: (item, record, index) => {
				return (
					<ExpandableText>
						{item || '-'}
					</ExpandableText>
				)
			},
		},
	]

	return (
		<Modal onClose={onClose}>
			<NominationHeader item={item} />

			<div className={cl('my-4')}>
				<AntdTable
					columns={columns}
					dataSource={data}
					pagination={false}
					rowKey={record => record.key}
				/>
			</div>
		</Modal>
	)
}